var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiaP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2651 1.18863L24.3675 7.53606C24.4823 7.71945 24.5343 7.93499 24.5154 8.15025C24.4965 8.36552 24.4079 8.56887 24.2629 8.72972L13.2712 21.3923C13.1777 21.4893 13.0658 21.567 12.942 21.621C12.8182 21.675 12.685 21.7042 12.5498 21.7068C12.4136 21.7112 12.2782 21.6852 12.1534 21.6307C12.0286 21.5763 11.9176 21.4948 11.8284 21.3923L0.743044 8.70101C0.592483 8.54231 0.500977 8.33718 0.483702 8.11964C0.466426 7.90209 0.524418 7.68521 0.648061 7.50496L4.75519 1.15514C4.83616 1.01972 4.95161 0.90795 5.08988 0.831093C5.22814 0.754235 5.38434 0.715014 5.54271 0.717387H19.444C19.6088 0.724407 19.7696 0.770913 19.9126 0.852954C20.0555 0.934994 20.1765 1.05015 20.2651 1.18863Z",
    fill: "#FF417D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaP);
export default __webpack_public_path__ + "static/media/dia_p.2d2707cae0cca7fed91c05fc4bef9915.svg";
export { ForwardRef as ReactComponent };